import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useState, useMemo } from 'react';
import { ceil, sortedUniq, sortBy } from 'lodash';
import { Card, Grid, Heading, Table } from '@enterprise-ui/canvas-ui-react';

var _excluded = ["name", "showHeader", "columnDefs", "defaultColumnDef", "rowData", "rowCount", "pageNum", "pageSize", "tableActions", "subHeader", "onPaginationChange", "onSortChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultTableProps = {
  fixedHeader: true,
  alternateRowColor: true,
  scrollableWidth: true,
  cellPadding: 'dense',
  showGrid: false
};
var defaultColDef = {
  sortable: false,
  resizable: true
};

// TODO - See if there's a possible need for client-side pagination
var NovaTable = function NovaTable(_ref) {
  var name = _ref.name,
    _ref$showHeader = _ref.showHeader,
    showHeader = _ref$showHeader === void 0 ? false : _ref$showHeader,
    columnDefs = _ref.columnDefs,
    _ref$defaultColumnDef = _ref.defaultColumnDef,
    defaultColumnDef = _ref$defaultColumnDef === void 0 ? {} : _ref$defaultColumnDef,
    rowData = _ref.rowData,
    rowCount = _ref.rowCount,
    _ref$pageNum = _ref.pageNum,
    pageNum = _ref$pageNum === void 0 ? 1 : _ref$pageNum,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 20 : _ref$pageSize,
    tableActions = _ref.tableActions,
    subHeader = _ref.subHeader,
    onPaginationChange = _ref.onPaginationChange,
    onSortChange = _ref.onSortChange,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(pageSize),
    _useState2 = _slicedToArray(_useState, 1),
    initialPageSize = _useState2[0];
  var pageCount = useMemo(function () {
    return ceil(rowCount / pageSize);
  }, [rowCount, pageSize]);
  var changePageSize = function changePageSize(newPagination) {
    onPaginationChange(1, newPagination.newPageSize);
  };
  var goToNextPage = function goToNextPage() {
    onPaginationChange(pageNum + 1, pageSize);
  };
  var goToPreviousPage = function goToPreviousPage() {
    onPaginationChange(pageNum - 1, pageSize);
  };
  var goToFirstPage = function goToFirstPage() {
    onPaginationChange(1, pageSize);
  };
  var goToLastPage = function goToLastPage() {
    onPaginationChange(pageCount, pageSize);
  };
  var goToPage = function goToPage(newPagination) {
    onPaginationChange(newPagination.newPage, pageSize);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "hc-pa-normal"
  }, (showHeader || tableActions) && /*#__PURE__*/React.createElement(Grid.Container, {
    spacing: "normal",
    justify: "space-between",
    className: "hc-pa-md"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, showHeader && /*#__PURE__*/React.createElement(Heading, {
    size: 3
  }, name)), /*#__PURE__*/React.createElement(Grid.Item, null, tableActions)), subHeader && /*#__PURE__*/React.createElement("div", {
    className: "hc-pa-normal"
  }, subHeader), /*#__PURE__*/React.createElement(Table, _extends({
    name: name,
    className: 'nova-table'
  }, defaultTableProps, restProps, {
    data: {
      columnDefs: columnDefs.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          onSort: onSortChange
        });
      }),
      rowData: rowData,
      defaultColDef: _objectSpread(_objectSpread({}, defaultColDef), defaultColumnDef)
    }
    // TODO - Find the simplest way to make this user configurable
    ,
    pagination: {
      type: 'server',
      currentPage: pageNum,
      initialPageSize: initialPageSize,
      pageSize: pageSize,
      pageSizeOptions: sortedUniq(sortBy([initialPageSize, 20, 50, 100])),
      totalItems: rowCount,
      totalPages: pageCount,
      onRequestFirst: goToFirstPage,
      onRequestLast: goToLastPage,
      onRequestNext: goToNextPage,
      onRequestPrev: goToPreviousPage,
      onRequestPage: goToPage,
      onPageSizeChange: changePageSize
    }
  })));
};

export { NovaTable as default };
